import { price as priceUtils } from '@eti/utils';
import { getTotalPrice, SELECTBOX_VALUE } from '../../common/utils/selectBoxOptions';
import { cleanText, TRACKING_PROPERTIES, TRACKING_VALUES } from '../../custom-hooks/useProductSnowplowTracking';
import { SELECTBOX_TEST_ID } from '../containers/FlexibleTicket';
const isOptionSelected = currentTarget => {
  var _currentTarget$getAtt, _currentTarget$getAtt2;
  return (_currentTarget$getAtt = currentTarget === null || currentTarget === void 0 || (_currentTarget$getAtt2 = currentTarget.getAttribute('data-headlessui-state')) === null || _currentTarget$getAtt2 === void 0 ? void 0 : _currentTarget$getAtt2.includes('selected')) !== null && _currentTarget$getAtt !== void 0 ? _currentTarget$getAtt : false;
};
const handleAllTravelersSelected = async (formattedOptions, sendAddToCartEvent, updateContext) => {
  await updateContext({
    quantity: formattedOptions.length - 2
  });
  sendAddToCartEvent({
    addToCart: true,
    value: TRACKING_VALUES.ALL_PASSENGERS
  });
};
const handleNoneTravelersSelected = async (options, sendAddToCartEvent, updateContext) => {
  const totalPrice = getTotalPrice(options === null || options === void 0 ? void 0 : options.map(option => ({
    priceRaw: option.priceRaw
  })));
  const formattedPrice = cleanText(priceUtils.formatPrice(totalPrice));
  await updateContext({
    quantity: options.length,
    price: formattedPrice
  });
  sendAddToCartEvent({
    addToCart: false
  });
};
const handleSingleTravelerSelected = async (currentTarget, sendAddToCartEvent, updateContext) => {
  const isOptionAlreadySelected = isOptionSelected(currentTarget);
  await updateContext({
    quantity: 1
  });
  sendAddToCartEvent({
    addToCart: !isOptionAlreadySelected,
    value: TRACKING_VALUES.SINGLE_PASSENGER
  });
};
export const sendSnowplowTracking = async (_ref, _ref2, formattedOptions, options, updateContext, sendAddToCartEvent) => {
  let {
    currentTarget
  } = _ref;
  let {
    value: selectedOption
  } = _ref2;
  const isOptionAlreadySelected = isOptionSelected(currentTarget);
  const isAllTravelersSelected = selectedOption === SELECTBOX_VALUE.ALL;
  const isNoneTravelerSelected = selectedOption === SELECTBOX_VALUE.NONE;
  const isSingleTravelerSelected = !isAllTravelersSelected && !isNoneTravelerSelected;
  if (isAllTravelersSelected && !isOptionAlreadySelected) {
    await handleAllTravelersSelected(formattedOptions, sendAddToCartEvent, updateContext);
  } else if (isNoneTravelerSelected && !isOptionAlreadySelected) {
    await handleNoneTravelersSelected(options, sendAddToCartEvent, updateContext);
  } else if (isSingleTravelerSelected) {
    await handleSingleTravelerSelected(currentTarget, sendAddToCartEvent, updateContext);
  }
};
export const attachDropDownClickListener = (rootElement, sendClickEvent) => {
  var _rootElement$current;
  const button = (_rootElement$current = rootElement.current) === null || _rootElement$current === void 0 ? void 0 : _rootElement$current.querySelector(`[data-testid="${SELECTBOX_TEST_ID}"]`);
  const handleButtonClick = event => {
    var _rootElement$current2, _rootElement$current3;
    const isDropDownClose = !((_rootElement$current2 = rootElement.current) !== null && _rootElement$current2 !== void 0 && (_rootElement$current3 = _rootElement$current2.querySelector) !== null && _rootElement$current3 !== void 0 && (_rootElement$current3 = _rootElement$current3.call(_rootElement$current2, "[role='listbox']")) !== null && _rootElement$current3 !== void 0 && _rootElement$current3.isConnected);
    const shouldSendEvent = event.target === button && isDropDownClose;
    if (shouldSendEvent) {
      sendClickEvent({
        property: TRACKING_PROPERTIES.VIEW_OPTIONS
      });
    }
  };
  if (button) {
    button.addEventListener('click', handleButtonClick);
    return () => {
      button.removeEventListener('click', handleButtonClick);
    };
  }
  return () => {};
};
//# sourceMappingURL=snowplow.js.map